export default __webpack_public_path__ + "static/media/polkadot-new-dot-logo.4345f3e4.svg";